import React from 'react';

const ResultModal = ({ title, message, variant = 'success', onClose }) => (
  <div className="modal" role="dialog" aria-modal="true" aria-labelledby="result-modal-title">
    <div className="backdrop" onClick={onClose} aria-hidden="true" />
    <div className="modal-content">
      <h2 id="result-modal-title">{title}</h2>
      <p className={variant === 'error' ? 'error hospital-credentials-result-message' : 'hospital-credentials-result-message'}>
        {message}
      </p>
      <div className="actions">
        <button type="button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  </div>
);

export default ResultModal;
